import React from 'react';

import { GetFAQResponse } from '~api/api';

export const GlobalStateContext = React.createContext<GetFAQResponse | undefined>(undefined);

export function useGlobalState() {
  const globalState = React.useContext(GlobalStateContext);
  if (globalState !== undefined) {
    return globalState;
  }
  throw 'GlobalStateContext is not yet defined, you are probably using it in a wrong place';
}
